import { Matrix4 } from "three";
import { FETreatmentGeneration } from "./Mesh";
import { splitTreatmentGeneration } from "./Split";

export let upperMatrix: Matrix4,
  lowerMatrix: Matrix4,
  upperMatrixInversed: Matrix4,
  lowerMatrixInversed: Matrix4,
  BJStepHeatmap: [] = [],
  isBiteJumpActive: Boolean = true;

export function setIsBiteJumpActive(state: Boolean, update: Boolean = true) {
  isBiteJumpActive = state;
  if (update) {
    FETreatmentGeneration.updateHeatMaps(FETreatmentGeneration.currentStep);
    splitTreatmentGeneration.updateHeatMaps(
      splitTreatmentGeneration.currentStep,
    );
  }
}
function setUpperBJMatrix(matrix: Matrix4) {
  upperMatrix = matrix;
  upperMatrixInversed = upperMatrix.clone().invert();
}
function setLowerBJMatrix(matrix: Matrix4) {
  lowerMatrix = matrix;
  lowerMatrixInversed = lowerMatrix.clone().invert();
}

export function setBJMatrices(array: {}) {
  if (Object.keys(array).length !== 32) {
    console.log(`BJ data ${array} is wrong`);
  }

  const upperMatrix: Matrix4 = new Matrix4(
    1,
    array["4"],
    array["8"],
    array["12"],
    array["1"],
    1,
    array["9"],
    array["13"],
    array["2"],
    array["6"],
    1,
    array["14"],
    array["3"],
    array["7"],
    array["11"],
    1,
  );
  const lowerMatrix: Matrix4 = new Matrix4(
    1,
    array["20"],
    array["24"],
    array["28"],
    array["17"],
    1,
    array["25"],
    array["29"],
    array["18"],
    array["22"],
    1,
    array["30"],
    array["19"],
    array["23"],
    array["27"],
    1,
  );

  setUpperBJMatrix(upperMatrix);
  setLowerBJMatrix(lowerMatrix);
}
